<template>
	<div class="system-selection-layout">
		<div class="system-selection-main">
			<div class="question-header">
				<div class="question-container">
					<span class="question-title">
						Which integration system should this service use?
					</span>
				</div>
				<p class="question-help-text">
					Choose the integration system that this service is a part of. This determines where your data will be sent and how it will be authenticated.
				</p>
				<div class="question-actions">
					<Dropdown
						label="System *"
						:value="integrationId"
						:items="systemIntegrationItems"
						searchable
						rules="required"
						class="system-dropdown"
						:disabled="!userFullPermissions || hasTemplate"
						@input="$emit('update:integrationId', $event)"
					/>
				</div>
			</div>
			<!-- Brand dropdown is still hidden but value is maintained -->
			<div style="display: none;">
				<Dropdown
					:label="'Brand*' | useLabels"
					:value="(singleBrand ? defaultBrandInSelect : !clientMultiBranded ? 0 : brandId)"
					:items="filteredBrandOptions"
					custom-sort
					searchable
					:rules="{ required: clientMultiBranded}"
					class="cassie-input-width-md"
					tooltip-text="Select a specific brand name for this integration"
					:disabled="!userFullPermissions || !clientMultiBranded || singleBrand"
					@input="$emit('update:brandId', $event)"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import Dropdown from '../../../../../../shared/components/dropdown.vue'
import { singleBrand, defaultBrandInSelect, clientMultiBranded, brandOptions, UNIVERSAL_BRAND, UNIVERSAL_BRAND_ITEM } from '../../../../../../shared/state/brands.js'

export default {
	components: { Dropdown },
	props: {
		systemIntegrationItems: Array,
		brandId: Number,
		isEdit: Boolean,
		integrationId: Number,
		userFullPermissions: Boolean,
		hasTemplate: Boolean
	},
	setup () {
		return {
			brandOptions,
			clientMultiBranded,
			singleBrand,
			defaultBrandInSelect
		}
	},
	computed: {
		...mapGetters('auth', ['productAreaPermission', 'userHasUniversalBrand']),
		filteredBrandOptions () {
			const containsUniversal = brandOptions.value.map(brand => {
				return brand.value
			}).includes(UNIVERSAL_BRAND)

			if (containsUniversal || !this.isEdit || this.cloneMode) {
				return brandOptions.value
			} else {
				return [
					UNIVERSAL_BRAND_ITEM,
					...brandOptions.value
				]
			}
		},
		effectiveBrandId () {
			// For new integrations, always use 0
			// For edits, preserve the existing brandId
			if (this.isEdit) {
				return this.brandId
			} else {
				return 0
			}
		}
	},
	created () {
		// Ensure the brand value is properly set on component creation
		this.$emit('update:brandId', this.effectiveBrandId)
	}
}
</script>

<style lang="scss" scoped>
.system-selection-layout {
	width: 100%;
	min-height: 500px;
}

.system-selection-main {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
}

.question-header {
	margin-bottom: 24px;
}

.question-container {
	display: flex;
	align-items: center;
	gap: 8px;
}

.question-title {
	font-size: 16px;
	font-weight: 500;
	color: var(--global-foreground);
	margin: 0;
	line-height: 1;
	flex-shrink: 0;
}

.question-help-text {
	font-size: 14px;
	color: var(--global-muted-foreground);
	margin: 16px 0 0 0;
	line-height: 1.4;
}

.question-actions {
	margin-left: auto;
}

.system-dropdown {
	width: 100%;
	max-width: 400px;
}

// Custom validation error styling - use brand colors instead of red
:deep(.v-text-field.error--text) {
	.v-label {
		color: var(--global-color-orange-darken-3) !important; // Amber color instead of red
	}

	.v-input__control .v-input__slot {
		border-color: var(--global-color-orange-darken-3) !important; // Amber border
	}

	.v-messages__message {
		color: #92400e !important; // Darker amber for message text
		font-weight: 500;
	}
}

:deep(.v-select.error--text) {
	.v-label {
		color: var(--global-color-orange-darken-3) !important;
	}

	.v-input__control .v-input__slot {
		border-color: var(--global-color-orange-darken-3) !important;
	}

	.v-messages__message {
		color: #92400e !important;
		font-weight: 500;
	}
}
</style>
